import { FC } from 'react'
import { Modal } from 'react-bootstrap'
import { FilterReportRushHourForm } from './FilterReportRushHourForm'
import { FilterReportRushHourModalHeader } from './FilterReportRushHourModalHeader'

type Props = {
  show: boolean
  closeModal: () => void
}

const FilterReportRushHourModal: FC<Props> = ({show, closeModal}) => {
  return (
    <>
      <Modal className='modal fade' dialogClassName='modal-xl' show={show} onHide={closeModal}>
        <div className='modal-content'>
          <FilterReportRushHourModalHeader closeModal={closeModal} />
          <div className='modal-body scroll-y'>
            <FilterReportRushHourForm closeModal={closeModal} />
          </div>
        </div>
      </Modal>
    </>
  )
}

export { FilterReportRushHourModal }

